module.exports = __webpack_public_path__ + "static/media/tonitLogoLight.b96eda50.png";